import React from 'react'
import { createPortal } from 'react-dom'
import { RouterProvider } from 'react-router'
import { ToastContainer } from 'react-toastify'

import { TooltipProvider } from './components/ui/tooltip'
import useHelper from './hooks/useHelper'
import useMediaQuery from './hooks/useMediaQuery'
import useRem from './hooks/useRem'
import useWatcher from './hooks/useWatcher'
import router from './routes'

const App: React.FC = () => {
  const { gtXL } = useMediaQuery()
  useWatcher()
  useRem()
  useHelper()

  return (
    <>
      {createPortal(
        <div className="Toastify-Wrapper">
          <ToastContainer
            hideProgressBar
            closeOnClick
            theme="dark"
            position={gtXL ? 'bottom-right' : 'top-center'}
            closeButton={!gtXL}
            draggable="touch"
            draggablePercent={30}
          />
        </div>,
        document.body
      )}

      <TooltipProvider delayDuration={0}>
        <RouterProvider router={router} />
      </TooltipProvider>
    </>
  )
}

export default App
